<div
  class="ddc-read-word-mobile-sheet"
  [ngClass]="{
    'dark-theme': _isDarkTheme,
    'light-theme': _isLightTheme,
    'paper-theme': _isPaperTheme,
  }"
>
  <!-- Header with word title and privacy -->
  <div class="sheet-header sticky-header">
    <div class="header-left">
      <ddc-text-gradient
        class="text-xl"
        [_icon]="'filter_alt'"
        [_text]="type() === 'words' ? 'Filter words' : 'Filter pairs'"
        [_type]="'1'"
      ></ddc-text-gradient>
    </div>
  </div>
  <mat-divider></mat-divider>

  <!-- Content section -->
  <form class="add-mobile-form" [formGroup]="_form">
    <!-- Form Error -->
    @if (_form.errors || _addError) {
      <div class="alert alert-danger">
        <div>{{ _addError }}</div>
        @if (_isSubscriptionError) {
          <div>Please upgrade your subscription to continue.</div>
        }
      </div>
    }

    <!-- Word -->
    <div class="add-mobile-form-main">
      <!-- Language word -->
      <div class="filter-languages">
        <mat-form-field>
          <mat-label><mat-icon>language</mat-icon>&nbsp;&nbsp;Language</mat-label>
          <mat-select
            formControlName="_1_language"
            [(value)]="_selectedLanguage"
            (selectionChange)="onLanguageChange($event)"
          >
            <mat-option *ngFor="let language of languages" [value]="language.raw_value">
              {{ language.view_value }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Language 2 for pair -->
        <mat-form-field *ngIf="type() === 'pairs'">
          <mat-label><mat-icon>language</mat-icon>&nbsp;&nbsp;To Language</mat-label>
          <mat-select formControlName="_2_language" [(value)]="_selectedLanguage2">
            <mat-option *ngFor="let language of languages" [value]="language.raw_value">
              {{ language.view_value }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- Article  -->
      <mat-form-field>
        <mat-label>Article</mat-label>
        <mat-select formControlName="_1_article" [disabled]="!_selectedLngHasArticle" [(value)]="_selectedArticle">
          <mat-option *ngFor="let article of articles" [value]="article.raw_value">
            {{ article.view_value }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- POS  -->
      <mat-form-field>
        <mat-label>Pos</mat-label>
        <mat-select formControlName="_1_pos" [(value)]="_selectedPos">
          <mat-option *ngFor="let pos of poses" [value]="pos.raw_value">
            {{ pos.view_value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <mat-divider></mat-divider>

    <!-- Submit Button -->
    <div class="mobile-buttons">
      <div></div>
      <div class="ddc-mobile-buttons-right">
        <button class="add-dialog-close-btn" mat-button type="button" (click)="closeDialog()">Clear Filters</button>
        <ddc-button-s-one
          *ngIf="!_wordCreated && !_pairCreated"
          [_isLoading]="EditWordPairDicCommand.isExecuting"
          [_label]="_submitBtnText"
          [command]="EditWordPairDicCommand"
          (click)="closeDialog()"
        ></ddc-button-s-one>
      </div>
    </div>
  </form>
</div>
